<template>
  <v-container fluid class="tp-page">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id"
          label="Selecione o Evento" @input="carregaInscritos()" color="#00695C"></v-select>
      </v-col>
    </v-row>
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Inscritos</h1>
          <p class="tp-page-sub">{{ inscritos.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-tooltip bottom v-if="user && user.igrejaId && user.igrejaId !== '6390de5538a3bc18300a2022'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#00695C" outlined depressed rounded v-on="on" v-bind="attrs" @click="abrirLinkPublico('/escola-ministerial')">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Abrir link público de inscrição (Escola Ministerial)</span>
          </v-tooltip>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="search" :headers="headers" :items="inscritos" sort-by="nome">
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small color="error" class="mr-2" @click="deleteItem(item)" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">delete</v-icon>
            <v-btn icon small @click="seeItem(item)">
              <v-icon small color="#00695C">mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum cadastro encontrado</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{ search }}" não trouxe resultados</v-alert>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <td>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</td>
          </template>
          <template v-slot:[`item.idade`]="{ item }">
            <td>{{ item.idade }} anos</td>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <br>
    <v-dialog v-model="dialog" max-width="350px">
      <v-card class="tp-card">
        <v-card-title style="justify-content: center; padding: 8px;">
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto" style="color:#00253E">Realizar checkin manual</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto">Nome: {{ nome }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto">Código: {{ checkin.cod_incricao }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn :loading="loading" dark depressed block color="#00695C" style="border-radius: 7px;" large
                  @click="realizaCheckin">Validar</v-btn>
              </v-flex>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="error" style="border-radius: 7px;" large
                  @click="close">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoDadosInscricao" max-width="1000px" scrollable>
      <v-card class="tp-card">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p style="margin-bottom: 5px">Informações da inscrição</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C" dense hide-details
                  :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-select v-model="editedItem.sexo" outlined label="Sexo" color="#00695C" :items="sexos" hide-details
                  item-text="text" item-value="value" dense :readonly="editedIndex != -1"></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.dataNascimento" label="Data de Nascimento" outlined color="#00695C"
                  v-mask="'##/##/####'" dense hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.idade" label="Data de Nascimento" outlined color="#00695C" dense
                  hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.celula" outlined label="Célula" color="#00695C" dense hide-details
                  :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-select v-model="editedItem.statusPagamento" outlined label="Status de Pagamento" color="#00695C"
                  :items="statusPagamento" hide-details item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model.lazy="editedItem.valor" outlined label="Valor" color="#00695C" hide-details dense
                  prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12"
                v-if="editedItem.nomePai || editedItem.cpfPai || editedItem.telefonePai || editedItem.celulaPai">
                <p style="margin-bottom: 5px">Dados do pai</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.nomePai">
                <v-text-field v-model="editedItem.nomePai" outlined label="Nome do pai" color="#00695C" dense
                  hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.cpfPai">
                <v-text-field v-model="editedItem.cpfPai" outlined label="CPF do pai" color="#00695C" dense hide-details
                  :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.telefonePai">
                <v-text-field v-model="editedItem.telefonePai" outlined label="Telefone do pai" color="#00695C" dense
                  v-mask="'(##) #####-####'" hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.celulaPai">
                <v-text-field v-model="editedItem.celulaPai" outlined label="Célula do pai" color="#00695C" dense
                  hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12"
                v-if="editedItem.nomeMae || editedItem.cpfMae || editedItem.telefoneMae || editedItem.celulaMae">
                <p style="margin-bottom: 5px">Dados da mãe</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.nomeMae">
                <v-text-field v-model="editedItem.nomeMae" outlined label="Nome da mãe" color="#00695C" dense
                  hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.cpfMae">
                <v-text-field v-model="editedItem.cpfMae" outlined label="CPF da mãe" color="#00695C" dense hide-details
                  :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.telefoneMae">
                <v-text-field v-model="editedItem.telefoneMae" outlined label="Telefone da mãe" color="#00695C" dense
                  v-mask="'(##) #####-####'" hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.celulaMae">
                <v-text-field v-model="editedItem.celulaMae" outlined label="Célula da mãe" color="#00695C" dense
                  hide-details :readonly="editedIndex != -1"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text @click="close">Fechar</v-btn>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add px-6" @click="salvarPagamento">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-md v-show="false">
      <v-layout row wrap id="printInscricao" style="padding: 15px">
        <v-flex xs12 sm12 lg12>
          <img src="../assets/liberdade.png" width="180px">
        </v-flex>
        <v-flex xs12 sm12 lg12>
          <br>
          <p style="font-size: 18px; text-align: center"><b>CADASTRO DO PARTICIPANTE - ED2022 4, 5 e 6 MARÇO 2022</b>
          </p>
          <br>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME</b></p>
          <p style="padding-left: 3px">{{ impressao.nome }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CPF</b></p>
          <p style="padding-left: 3px">{{ impressao.cpf }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>IDENTIFICAÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.numero }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>DATA DE NASCIMENTO</b></p>
          <p style="padding-left: 3px">{{ impressao.dataNascimento }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>SEXO</b></p>
          <p style="padding-left: 3px">{{ impressao.sexo }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefone }}</p>
        </v-flex>
        <v-flex xs5 sm5 lg5 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>PREFERE SER CHAMADO(A) POR</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeSocial }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TIPO DE INSCRIÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.tipo }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TAMANHO DA CAMISA</b></p>
          <p style="padding-left: 3px">{{ impressao.tamanhoCamisa }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações da célula</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.celula }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>LÍDER DA CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeLider }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE DO LÍDER</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneLider }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações de contato dos pais</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME DA MÃE</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeMae }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneMae }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME DO PAI</b></p>
          <p style="padding-left: 3px">{{ impressao.nomePai }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefonePai }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações dos três amigos</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 1</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo1 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo1 }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 2</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo2 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo2 }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 3</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo3 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo3 }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <br>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>USA MEDICAMENTO CONTÍNUO?</b></p>
          <p style="padding-left: 3px" v-if="impressao.usaMedicamento == true">SIM</p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>MEDICAMENTO UTILIZADO</b></p>
          <p style="padding-left: 3px">{{ impressao.medicamento }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>ALÉRGICO A ALGUMA MEDICAÇÃO</b></p>
          <p style="padding-left: 3px" v-if="impressao.possuiAlergia == true">SIM</p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>ALERGIA</b></p>
          <p style="padding-left: 3px">{{ impressao.alergia }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>POSSUI RESTRIÇÃO ALIMENTAR</b></p>
          <p style="padding-left: 3px" v-if="impressao.restricaoAlimentar == true">SIM</p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>RESTRIÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.restricoes }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NECESSITA ATENDIMENTO ESPECIAL</b></p>
          <p style="padding-left: 3px" v-if="impressao.atendimentoEspecial == true">SIM</p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NECESSIDADE</b></p>
          <p style="padding-left: 3px">{{ impressao.necessidades }}</p>
        </v-flex>
      </v-layout>
    </v-container>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    <div v-show="true">
      <Inscricoes ref="inscricoes"></Inscricoes>
    </div>
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import Inscricoes from '../componentes/inscricoes.vue'
import moment from 'moment'
import axios from 'axios'
import PH from 'print-html-element'
import { mapState } from 'vuex'

export default {
  components: {
    Snackbar,
    Loading,
    Inscricoes,
  },
  data: () => ({
    dialogoDadosInscricao: false,
    eventoId: '',
    eventoIdAtual: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    nome: '',
    addUser: false,
    dialog: false,
    checkin: {
      cod_incricao: '',
      tipo: '',
      eventoId: '',
      userValidatorId: '',
    },
    statusPagamento: ['CANCELADO', 'ESTORNADO', 'PAGO', 'PENDENTE'],
    sexos: ['MASCULINO', 'FEMININO'],
    tipos: ['MEMBRO', 'VISITANTE'],
    formaPagamento: [
      { value: 'BOLETO', text: 'BOLETO' },
      { value: 'CARTAO', text: 'CARTÃO' },
      { value: 'CORTESIA', text: 'CORTESIA' },
      { value: 'EM MAOS', text: 'EM MÃOS' },
      { value: 'PIX', text: 'PIX' },
    ],
    headers: [
      { text: 'Nome', align: 'start', value: 'nome', },
      { text: 'Sexo', value: 'sexo' },
      { text: 'Telefone', value: 'whatsApp' },
      { text: 'Data de Nascimento', value: 'dataNascimento' },
      { text: 'Idade', value: 'idade' },
      { text: 'Célula', value: 'celula' },
      { text: 'Status Pagamento', value: 'statusPagamento' },
      { text: 'Melhor Dia', value: 'melhorDia' },
      { text: 'Realizada em', value: 'created' },
      { text: 'Ações', value: 'action', align: 'center', sortable: true },
    ],
    editedIndex: -1,
    editedItem: {
      nome: '',
      sexo: '',
      dataNascimento: '',
      celula: '',
      idade: '',
      nomeMae: '',
      cpfMae: '',
      telefoneMae: '',
      celulaMae: '',
      nomePai: '',
      cpfPai: '',
      telefonePai: '',
      celulaPai: '',
      valor: '',
    },
    defaultItem: {
      nome: '',
      sexo: '',
      dataNascimento: '',
      celula: '',
      idade: '',
      nomeMae: '',
      cpfMae: '',
      telefoneMae: '',
      celulaMae: '',
      nomePai: '',
      cpfPai: '',
      telefonePai: '',
      celulaPai: '',
      valor: '',
    },
    eventos: [],
    inscritos: [],
    impressao: [],
    celulas: [],
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR INSCRIÇÃO' : 'FICHA DE INSCRIÇÃO'
    }
  }),

  mounted() {
    this.carregaCelulas()
    this.carregaDados() 
  },

  methods: {
    abrirLinkPublico(rota) {
      const id = this.user && this.user.igrejaId ? this.user.igrejaId : ''
      if (id) window.open(`${window.location.origin}${rota}?igrejaId=${id}`, '_blank')
    },

    async printItem(item) {
      this.isLoading = true
      try {
        await axios.get(`${baseApiUrl}inscricoes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
          if (response.data) {
            this.impressao = Object.assign({}, response.data)
            setTimeout(() => {
              if (this.eventoId == '61ec94340cf286040f6c78ad') {
                PH.printElement(document.getElementById('printInscricao'))
              } else if (this.eventoId == '61ec9a360cf286040f6c78ae') {
                PH.printElement(document.getElementById('printEquipe'))
              }
              this.isLoading = false
            }, 50);
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao imprimir. Tente novamente", "DESCULPE")
      }
    },

    async carregaCelulas() {
      await axios.get(baseApiUrl + 'Celulas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "fields":{"nome": true, "id": true}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.celulas = response.data
          }
        })
    },

    async carregaDados() {
      this.isLoading = true
      let url
      if (this.user.tipo == 'KIDS' || this.user.tipo == 'EVENTO') {
        url = 'Eventos?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"},{"tipo":"EM"}]}}'
      } else {
        url = 'Eventos?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"}]}}'
      }
      await axios.get(baseApiUrl + url + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.eventos = response.data.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual)
              this.eventoId = this.eventoIdAtual
          } else
            this.isLoading = false
        })
      await this.carregaInscritos() 
    },

    preparaImpressao(array) {
      var pr = this;
      pr.$refs.inscricoes.preparaImpressao(array)
    },

    print() {
      var vm = this;
      vm.$refs.inscricoes.print();
    },

    async save() {
      this.isLoading = true
      if (this.editedIndex != -1) {
        this.editedItem.nome = this.editedItem.nome
        this.editedItem.cpf = this.editedItem.cpf
        this.editedItem.email = this.editedItem.email.trim()
        this.editedItem.statusPagamento = this.editedItem.statusPagamento
        await axios.patch(`${baseApiUrl}inscricoes/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaDados()
            }
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      } else {
        this.editedItem.empresaId = this.companyobj.id
        this.editedItem.igrejaId = this.user.igrejaId
        await axios.post(`${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem).then(res => {
          this.id_evento = res.data.id
          if (res.data != null) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento, tente novamente", "ERRO")
        })
      }
      this.close()
    },

    compare(a) {
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      else if (dataC < dataA)
        comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      let data = data_hora.substr(0, 10).split('-')
      data = data[2] + '/' + data[1] + '/' + data[0]
      let hora = data_hora.substr(11, 8)
      return data + ' ' + hora
    },

    formatDateBrz(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null
      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async carregaInscritos() {
      this.inscritos = [];
      this.isLoading = true; 

      let filterConditions = [
        { "eventoId": this.eventoId }
      ];

      if (this.user && this.user.tipo === 'GERENTE') {
        filterConditions.push({ "membro.recadastramento": true });
      }

      const filter = {
        where: {
          and: filterConditions
        },
        order: "nome ASC",
        include: "membro"
      };

      try {
        const response = await axios.get(baseApiUrl + `Inscricoes?filter=${JSON.stringify(filter)}&access_token=${sessionStorage.getItem('accToken')}`);
        let inscricoesProcessadas = [];
        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].membro) {
                inscricoesProcessadas.push({
                  "nome": response.data[i].nome,
                  "sexo": response.data[i].sexo,
                  "dataNascimento": response.data[i].membro.dataNascimento,
                  "idade": this.calculaIdade(response.data[i].membro.dataNascimento),
                  "created": response.data[i].created,
                  "celula": this.nomeCelula(response.data[i].membro.celulaId).trim(),
                  "maeId": response.data[i].membro.maeId,
                  "paiId": response.data[i].membro.paiId,
                  "id": response.data[i].id,
                  "statusPagamento": response.data[i].statusPagamento,
                  "melhorDia": response.data[i].melhorDia,
                  "whatsApp": response.data[i].whatsApp, 
                });
            }
          }
          this.inscritos = inscricoesProcessadas;
        }
      } catch (error) {
         // error
      } finally {
        this.isLoading = false; 
      }
    },

    async atualizaInscricao() {
      let inscritos = [];
      let maeResponse = '';
      let paiResponse = '';

      let filterConditions = [
        { "eventoId": this.eventoId }
      ];

      if (this.user && this.user.tipo === 'GERENTE') {
        filterConditions.push({ "membro.recadastramento": true });
      }

      const filter = {
        where: {
          and: filterConditions
        },
        order: "nome ASC",
        include: "membro"
      };

      await axios.get(baseApiUrl + `Inscricoes?filter=${JSON.stringify(filter)}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(async response => {
          if (response.data) {
            inscritos = response.data;
            for (let i = 0; i < inscritos.length; i++) {
              // Ensure inscritos[i].membro exists before accessing its properties
              if (inscritos[i].membro && inscritos[i].membro.maeId) {
                maeResponse = await axios.get(baseApiUrl + 'Membros/' + inscritos[i].membro.maeId + '?access_token=' + sessionStorage.getItem('accToken'));
              } else {
                maeResponse = '';
              }
              if (inscritos[i].membro && inscritos[i].membro.paiId) {
                paiResponse = await axios.get(baseApiUrl + 'Membros/' + inscritos[i].membro.paiId + '?access_token=' + sessionStorage.getItem('accToken'));
              } else {
                paiResponse = '';
              }

              let inscricao = {
                "nome": inscritos[i].nome,
                "sexo": inscritos[i].sexo,
                "eventoId": inscritos[i].eventoId,
                "checkin": inscritos[i].checkin,
                "checkout": inscritos[i].checkout,
                "membroId": inscritos[i].membroId,
                "created": inscritos[i].created,
                "id": inscritos[i].id,
                "igrejaId": inscritos[i].igrejaId,
                "whatsApp": maeResponse && maeResponse.data && maeResponse.data.telefone
                            ? maeResponse.data.telefone
                            : (paiResponse && paiResponse.data && paiResponse.data.telefone
                              ? paiResponse.data.telefone
                              : '')
              };
              await axios.patch(baseApiUrl + 'inscricoes/' + inscricao.id + '?access_token=' + sessionStorage.getItem('accToken'), inscricao);
            }
          }
        });
    },

    calculaIdade(dataNasc) {
      let dataAtual = new Date();
      let anoAtual = dataAtual.getFullYear();
      let anoNascParts = dataNasc.split('/');
      let diaNasc = anoNascParts[0];
      let mesNasc = anoNascParts[1];
      let anoNasc = anoNascParts[2];
      let idade = anoAtual - anoNasc;
      let mesAtual = dataAtual.getMonth() + 1;
      if (mesAtual < mesNasc) {
        idade--;
      } else {
        if (mesAtual == mesNasc) {
          if (new Date().getDate() < diaNasc) {
            idade--;
          }
        }
      }
      return idade;
    },

    nomeCelula(celulaId) {
      let nomeCelula
      this.celulas.filter(celula => {
        if (celula.id === celulaId) {
          nomeCelula = celula.nome
        }
      })
      return nomeCelula
    },

    async realizaCheckin() {
      this.loading = true
      await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 3:
                this.loading = false
                this.close()
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin realizada com sucesso!", "INFORMAÇÃO")
                break;
              case 1:
                this.close()
                vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin já realizado!", "INFORMAÇÃO")
                this.loading = false
                break;
              default:
                break;
            }
          } else {
            vm = this
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      await this.carregaInscritos()
      this.checkin.cod_incricao = ''
      this.checkin.tipo = ''
      this.checkin.eventoId = ''
      this.checkin.userValidatorId = ''
    },

    openDialog(item) {
      this.checkin.cod_incricao = item.cod_incricao
      this.checkin.tipo = 'CHECKIN'
      this.checkin.eventoId = this.eventoId
      this.checkin.userValidatorId = this.user.id
      this.nome = item.nome
      this.dialog = true
    },

    async editItem(item) {
      this.isLoading = true
      this.editedIndex = this.inscritos.indexOf(item)
      try {
        await axios.get(`${baseApiUrl}inscricoes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
          if (response.data) {
            this.pegaImagem(response.data.id)
            this.editedItem.nome = response.data.nome
            this.editedItem.cpf = response.data.cpf
            this.editedItem.email = response.data.email
            this.editedItem.statusPagamento = response.data.statusPagamento
            this.editedItem.id = response.data.id
            this.editedItem.telefone = response.data.telefone
            this.editedItem.cargo = response.data.cargo
            this.editedItem.empresa = response.data.empresa
            this.editedItem.nomeCracha = response.data.nomeCracha
            this.editedItem.tipo = response.data.tipo
            this.editedItem.sexo = response.data.sexo
            this.editedItem.celula = response.data.celula
            this.editedItem.infoVacina = this.exibeInformacaoVacina(response.data.infoVacina)
            this.editedItem.formOfPayment = response.data.formOfPayment
            this.editedItem.valorPago = response.data.valorPago
            this.editedItem.codigoTransacao = response.data.codigoTransacao
            this.editedItem.numero = response.data.numero
            this.editedItem.participantes = response.data.participantes
            this.dialogoDadosInscricao = true
            this.isLoading = false
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao editar inscrição", "DESCULPE")
      }
    },

    async pegaImagem(idInscricao) {
      await axios.get(`${baseApiUrl}ImagesDocs?filter={"where":{"inscricaoId":"${idInscricao}"}}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(response => {
          if (response.data.length != 0) {
            this.editedItem.arquivoComprovanteVacinal = response.data[0].arquivoComprovanteVacinal
          }
        })
    },

    async sendEmail(item) {
      this.isLoading = true
      this.editedItem.id = item.id
      try {
        await axios.post(`${baseApiUrl}Inscricoes/EmailRecuperaAcesso?access_token=${sessionStorage.getItem('accToken')}`, { "inscricaoId": this.editedItem.id }).then(res => {
          if (res.data) {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "E-mail enviado com sucesso!", "SUCESSO")
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
      }
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir: ' + item.nome + ' do evento?')
      if (r == true) {
        this.isLoading = true
        await axios.delete(`${baseApiUrl}Inscricoes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaDados()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    close() {
      this.dialog = false
      this.dialogoDadosInscricao = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async seeItem(item) {
      this.isLoading = true
      this.editedIndex = this.inscritos.indexOf(item)
      let maeResponse = ''
      let paiResponse = ''
      if (item.maeId) {
        maeResponse = await axios.get(baseApiUrl + 'Membros/' + item.maeId + '?access_token=' + sessionStorage.getItem('accToken'))
      }
      if (item.paiId) {
        paiResponse = await axios.get(baseApiUrl + 'Membros/' + item.paiId + '?access_token=' + sessionStorage.getItem('accToken'))
      }
      let dados = {
        "nome": item.nome,
        "sexo": item.sexo,
        "dataNascimento": item.dataNascimento,
        "celula": item.celula,
        "idade": item.idade + ' anos',
        "nomeMae": maeResponse && maeResponse.data ? maeResponse.data.nome : '',
        "cpfMae": maeResponse && maeResponse.data ? maeResponse.data.cpf : '',
        "telefoneMae": maeResponse && maeResponse.data ? maeResponse.data.telefone : '',
        "celulaMae": maeResponse && maeResponse.data && maeResponse.data.celulaId ? this.nomeCelula(maeResponse.data.celulaId).trim() : '',
        "nomePai": paiResponse && paiResponse.data ? paiResponse.data.nome : '',
        "cpfPai": paiResponse && paiResponse.data ? paiResponse.data.cpf : '',
        "telefonePai": paiResponse && paiResponse.data ? paiResponse.data.telefone : '',
        "celulaPai": paiResponse && paiResponse.data && paiResponse.data.celulaId ? this.nomeCelula(paiResponse.data.celulaId).trim() : '',
        "id": item.id,
        "statusPagamento": item.statusPagamento,
      }
      this.editedItem = Object.assign({}, dados)
      this.dialogoDadosInscricao = true
      this.isLoading = false
    },

    async salvarPagamento() {
      var vm = this
      this.isLoading = true
      await axios.patch(baseApiUrl + 'inscricoes/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), { "statusPagamento": this.editedItem.statusPagamento, "valor": this.editedItem.valor })
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoDadosInscricao = false
            this.carregaInscritos()
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
        })
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url('https://fonts.google.com/specimen/Roboto');
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>